<template>
  <div class="md-layout">
    <div v-if="$route.params.id" id="objectHeaderContentHidden" style="display: none;">
      <div><md-icon class="icon-color">{{formConfig.headerIcon}}</md-icon></div>
      <div>
        <h1 class="md-title icon-color content-wrap">{{recordData? recordData.name : ''}}</h1>
      </div>
    </div>
    <template v-if="$route.params.id">
      <md-tabs md-sync-route class="topNavTabs" :class="[
        { 'edit-mode': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
      ]">

        <md-tab id="tab-company" md-label="Company" :to="recordPath" exact>
          <div class="md-card md-layout-item md-small-size-100" >
          <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor"></ConfigForm>
          </div>
        </md-tab>

        <!-- Accounts tab -->
        <md-tab id="tab-accounts" md-label="Accounts" :to="recordPath + '/accounts'">
          <!-- <DynamoList v-if="$route && $route.meta.tab === 'accounts'" :list.sync="accountCompanyList" :filter="accountCompanyIdFilter"></DynamoList> -->
          <ElasticList 
            v-if="$route && $route.meta.tab === 'accounts'" 
            :list="accountsList" 
            :filter="accountCompanyIdFilter"
            ref="accountListRef"
          ></ElasticList>

          <md-dialog :md-active.sync="accountsList.showRelatedLinkDialog">
            <md-dialog-title>{{relateAccountsList.pageTitle}}</md-dialog-title>

            <md-dialog-content>
              <ElasticList
                v-if="recordData"
                :list.sync="relateAccountsList"
                :relateParamsId="$route.params.id"
                :exclude="existingAccountsFilter"
                relateRecordInputField="accountCompanyId"
              ></ElasticList>
            </md-dialog-content>

            <md-dialog-actions>
              <md-button class="md-theme-default" @click="accountsList.showRelatedLinkDialog = false; accountsList.needsRefresh = true;">Close</md-button>
            </md-dialog-actions>
          </md-dialog>
        </md-tab>

        <md-tab id="tab-services" md-label="Services" :to="recordPath + '/services'">
          <ElasticList v-if="$route && $route.meta.tab === 'services' && recordData" :onlyShowListIf="serviceAccountIds.length > 0" :list="servicesList" :filter="serviceCompanyIdFilter"></ElasticList>
        </md-tab>

        <!-- People tab -->
        <md-tab id="tab-people" md-label="People" :to="recordPath + '/people'">
          <ElasticList
            v-if="$route && $route.meta.tab === 'people'"
            :list.sync="personsList"
            :filter="personCompanyCompanyId"
            ref="personsListRef"
          ></ElasticList>

          <md-dialog :md-active.sync="personsList.showRelatedDialog">
            <md-dialog-title>{{relatePersonsList.pageTitle}}</md-dialog-title>
            <md-dialog-content>
              <ElasticList
                v-if="recordData"
                :list.sync="relatePersonsList"
                :rawFilter="relatePersonCompanyFilter"
                :relateRecordInput="{personCompanyPersonId: null, personCompanyCompanyId: $route.params.id}"
                relateRecordInputField="personCompanyPersonId"
              ></ElasticList>
            </md-dialog-content>

            <md-dialog-actions>
              <md-button class="md-theme-default" @click="personsList.showRelatedDialog = false">Close</md-button>
            </md-dialog-actions>
          </md-dialog>
        </md-tab>

        <!-- Cases tab -->
        <md-tab id="tab-cases" md-label="Cases" :to="recordPath + '/cases'">
          <CaseTab
            v-if="$route && $route.meta.tab === 'cases'" 
            :routeParamsId= "$route.params.id" 
            :caseListData= "casesList"
            :caseMapFilter="caseCompanyIdFilter"
            :relateRecordInput="caseServiceRelateRecordInput"
          />
        </md-tab>

        <!-- Tasks tab -->
        <md-tab id="tab-tasks" md-label="Tasks" :to="recordPath + '/tasks'">
          <TaskTab
            v-if="$route && $route.meta.tab === 'tasks'" 
            :routeParamsId= "$route.params.id" 
            :taskListData= "tasksList"
            :filter= "taskCompanyIdFilter"
          />
        </md-tab>
      </md-tabs>
    </template>

    <div v-else class="md-tabs topNavTabs md-alignment-left md-theme-default" :class="[
        { 'edit-mode': formConfig.pageMode == 'new' || formConfig.pageMode == 'edit' },
      ]"> 
      <div class="md-content md-tabs-content md-theme-default">
        <div class="md-tabs-container">
          <div id="tab-active" class="md-tab">
            <div class="md-card md-layout-item md-small-size-100">
              <ConfigForm :update="updateForm" :form="form" :$v="$v" :formConfig="formConfig" :recordData="recordData" :headerColor="headerColor"></ConfigForm>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Record from '@/mixins/Record';
  import Page from '@/mixins/Page';

  // Form validations
  import { required, numeric, minLength } from "vuelidate/lib/validators";
  import CaseTab from '@/components/CaseTab';
  import TaskTab from '@/components/TaskTab';
  import moment from 'moment';

  export default {
    name: "company",
    mixins: [Record, Page],
    components: {
      CaseTab,
      TaskTab
    },
    computed: {
      /**
       * Elasticsearch exclude filter to skip already added records
       * @returns {Mixed} null or Object
       */
      existingAccountsFilter() {
        let result = null;
        const items = this.accountsList.skipAccounts;
        if (!items || !items.length) {
          return result;
        }

        const filters = [];
        items.forEach(_item => filters.push({ match: { id: _item } }));
        if (filters.length) {
          result = { must_not: filters };
        }

        console.log('existingAccountsFilter result: ', result);
        return result;
      },
      serviceAccountIds: function () {
        let result = [];
        if (typeof this.recordData !== 'undefined' && this.recordData !== null && typeof this.recordData.accounts !== 'undefined' && typeof this.recordData.accounts.items !== 'undefined') {
          let accounts = this.recordData.accounts.items;
          accounts.forEach(account => {
            result.push(account.id);
          });
        }
        return result;
      },
      caseServiceRelateRecordInput: function() { return {'caseCompanyCaseId': null, 'caseCompanyCompanyId': this.$route.params.id}},
      caseCompanyIdFilter: function() { return { "match": { "caseCompanyCompanyId": this.$route.params.id }}; },
      taskCompanyIdFilter: function() {
        return [
          {
            match_phrase: {
              taskCompanyCompanyId: this.$route.params.id
            }
          },
          {
            term: {
              'esData.task.isAvailable': true,
            },
          },
        ];
      },
      //accountCompanyIdFilter: function () { return {"accountCompanyId": {"eq": this.$route.params.id }}; },
      accountCompanyIdFilter: function () { return {"match_phrase": { "accountCompanyId": this.$route.params.id }}; },
      serviceCompanyIdFilter: function () {
        let result = false;

        if (typeof this.recordData !== 'undefined' && this.recordData !== null && typeof this.recordData.accounts !== 'undefined') {
          if (this.serviceAccountIds.length === 0)
            result = null;
          else if (this.serviceAccountIds.length === 1)
            result = {"match": {"serviceAccountId.keyword": this.serviceAccountIds[0] }};
          else {
            result = { "bool": { "must": { "bool": { "should": [] }}}};
            this.serviceAccountIds.forEach(serviceAccId => {
              result.bool.must.bool.should.push({"match_phrase": {"serviceAccountId": serviceAccId }})
            });
            //result = {"match": {"serviceAccountId": this.serviceAccountIds.join(' ') }};
            // result = {"should": []};
            // serviceAccountIds.forEach(sai => {
            //   result.should.push({"match": {"serviceAccountId.keyword": sai }})
            // });
            //result = {"match": {"serviceAccountId.keyword": serviceAccountIds[0] }};
          }
        }
        return result;
      },
      personCompanyCompanyId: function () { return { match: { personCompanyCompanyId: this.$route.params.id } }; },
      relatePersonCompanyFilter: function () {
        let filter = null;
        const items = this.$reduce(this, 'recordData.persons.items');
        if (items && items.length) {
          const map = {};
          items.reduce((obj, item, index) => {
            const id = this.$reduce(item, 'person.id');
            if (!id) {
              return obj;
            }
            obj.id = { ne: id };
            if (index != (items.length - 1)) {
              obj.and = {};
              return obj.and;
            }
          }, map);
          if (map.id) {
            filter = { filter: map };
          }
        }
        return filter;
      },
    },
    data() {
      return {
        accountsList: {
          editPath: "accounts",
          pageTitle: "Accounts",
          pageIcon: "work",
          hideNewRecordButton: true,
          linkRelatedRecord: true,
          showRelatedLinkDialog: false,
          showNewExistingButton: true,
          filterFieldName: "accountCompanyId", //for new url
          buildCustomRoute: true, //for new url
          btnLabel: "Add",
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "description",
              click: "handleEdit"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          listQueryId: "searchAccounts",
          responseFieldName: "searchAccounts",
          deleteQueryId: "deleteAccount",
          disassociateRecord: { updateQueryId: "updateAccount", updateFieldId: "accountCompanyId" },
          columns: {
            name: { label: "Name", sortable: true },
            addressPhysical: { label: "Address", sortable: false },
            createdAt: { label: "Created", sortable: true, dateFilter: true },
            //company: { label: "Company", sortable: true }
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          tableData: [],
          searchedData: [],
          fuseSearch: null,
          skipAccounts: [],
          formatResponse: (data) => {
            let result = [];
            this.accountsList.skipAccounts = []; //reset

            if (data && typeof data.searchAccounts !== 'undefined' && data.searchAccounts.items && data.searchAccounts.items.length) {
              let items = data.searchAccounts.items;
              items.forEach((item) => {

                /** Format addresses for display */
                ['addressPhysical', 'addressMailing'].forEach(addressName => {
                  let itemAddress = item[addressName];
                  if (typeof itemAddress !== 'undefined' && itemAddress) {
                    item[addressName] = this.$format.JsonAddressToString(itemAddress);
                  }
                });
                /**
                 * ATLAS-935 Company > Account tab: DB value is showing in Address column for State and Country
                 * 
                 * Remove Country code and underscores from Address fields
                 */
                if(item.addressPhysical) {
                  item.addressPhysical = item.addressPhysical.replace(/US_|CA_|_/g, ' ').trim();
                }
                if(item.addressMailing) {
                  item.addressMailing = item.addressMailing.replace(/US_|CA_|_/g, ' ').trim();
                }

                //for exlude filter
                this.accountsList.skipAccounts.push(item.id);
                result.push(item);
              })
            }
            return result;
          }
        },
        // accountCompanyList: {
        //   showRelatedLinkDialog: false,
        //   needsRefresh: false,
        //   linkActive: true,
        //   itemActions: [
        //     {
        //       class: "md-just-icon md-warning md-simple",
        //       icon: "description",
        //       click: "handleEdit"
        //     },
        //     {
        //       class: "md-just-icon md-danger md-simple",
        //       icon: "close",
        //       click: "handleDelete"
        //     }
        //   ],
        //   editPath: "accounts",
        //   pageTitle: "Account",
        //   pageIcon: "work",
        //   listQueryId: "searchAccounts",
        //   updateQueryId: "updateAccount",
        //   updateQueryIdField: "accountCompanyId",
        //   deleteMessageTitle: "Are you sure you want to remove {objectName} from this Account?",
        //   deleteMessageText: "",
        //   columns: {
        //     name: { label: "Name", sortable: true },
        //     addressPhysical: { label: "Address", sortable: false },
        //     createdAt: { label: "Created", sortable: true, dateFilter: true }
        //   },
        //   currentSort: "name",
        //   currentSortOrder: "asc",
        //   pagination: {
        //     perPage: 25,
        //     currentPage: 1,
        //     perPageOptions: [5, 10, 25, 50],
        //     total: 0
        //   },
        //   tableData: [],
        //   searchedData: [],
        //   fuseSearch: null,
        //   formatResponse: (data) => {
        //     let result = [];
        //     if (data && data.searchAccounts && data.searchAccounts.items && data.searchAccounts.items.length) {
        //       this.$c.log('formatResponse data: ', data.items);

        //       data.searchAccounts.items.forEach((item) => {
        //         item.relateRecordId = item.id;
        //         /** Format addresses for display */
        //         ['addressPhysical', 'addressMailing'].forEach(addressName => {
        //           let itemAddress = item[addressName];
        //           if (typeof itemAddress !== 'undefined' && itemAddress) {
        //             item[addressName] = this.$format.JsonAddressToString(itemAddress);
        //           }
        //         });

        //         /**
        //          * ATLAS-935 Company > Account tab: DB value is showing in Address column for State and Country
        //          * 
        //          * Remove Country code and underscores from Address fields
        //          */
        //         if(item.addressPhysical) {
        //           item.addressPhysical = item.addressPhysical.replace(/US_|CA_|_/g, ' ').trim();
        //         }
        //         if(item.addressMailing) {
        //           item.addressMailing = item.addressMailing.replace(/US_|CA_|_/g, ' ').trim();
        //         }
        //         result.push(item);
        //       })
        //     }
            
        //     return result;
        //   },
        // },
        relateAccountsList: {
          hideListHeader: true,
          skipCardLayout: true,
          linkActive: true,
          editPath: "accounts",
          pageTitle: "Search for Account",
          pageIcon: "work",
          listQueryId: "searchAccountCustoms",
          responseFieldName: "searchAccounts",
          updateMutationId: "updateAccount",
          deleteQueryId: "deleteAccount",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleLink"
            }
          ],
          columns: {
            name: { label: "Name", sortable: true },
            addressPhysical: { label: "Address", sortable: false },
            createdAt: { label: "Created", sortable: true, dateFilter: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            this.$c.log(data);
            let result = [];
            let responseKey = 'searchAccounts';
            if (data && data[responseKey] !== 'undefined') {
              let items = data[responseKey].items;
              items.forEach((item) => {
                // if(item.company == null) {
                  ['addressPhysical', 'addressMailing'].forEach(addressName => {
                   let itemAddress = item[addressName];
                   if (typeof itemAddress !== 'undefined' && itemAddress) {
                    item[addressName] = this.$format.JsonAddressToString(itemAddress);
                   }
                  });
                // }

                /**
                 * ATLAS-935 Company > Account tab: DB value is showing in Address column for State and Country
                 * 
                 * Remove Country code and underscores from Address fields
                 */
                if(item.addressPhysical) {
                  item.addressPhysical = item.addressPhysical.replace(/US_|CA_|_/g, ' ').trim();
                }
                if(item.addressMailing) {
                  item.addressMailing = item.addressMailing.replace(/US_|CA_|_/g, ' ').trim();
                }

                result.push(item);
              });
            }
            return result; 
          },
        },
        personsList: {
          showRelatedDialog: false,
          linkRows: true,
          itemActions: [
            {
              class: "md-just-icon md-warning md-simple",
              icon: "description",
              click: "handleEdit"
            },
            {
              class: "md-just-icon md-danger md-simple",
              icon: "close",
              click: "handleDelete"
            }
          ],
          editPath: "people",
          pageTitle: "People",
          pageIcon: "people_alt",
          listQueryId: "searchPersonCompanys",
          responseFieldName: "searchPersonCompanys",
          deleteQueryId: "deletePersonCompany",
          deleteQueryIdField: "relateRecordId",
          deleteMessageTitle: "Are you sure you want to remove {objectName} from this Company?",
          deleteMessageText: "",
          deleteMessageNameFieldsIsInESData: true,
          deleteMessageNameFields: ['person.given_name', 'person.family_name'],
          columns: {
            'esData.person.given_name': { label: "First Name", sortable: true, esSort: true, esKeyword: true, esNested: true },
            'esData.person.family_name': { label: "Last Name", sortable: true, esSort: true, esKeyword: true, esNested: true },
            'esData.person.phone_mobile': { label: "Mobile", sortable: true, esSort: true, esKeyword: true, esNested: true },
            'esData.person.phone_number': { label: "Main Phone", sortable: true, esSort: true, esKeyword: true, esNested: true },
            'esData.person.email': { label: "Email", sortable: true, esSort: true, esKeyword: true, esNested: true },
            'esData.person.ssn': { label: "SSN", sortable: true, esSort: true, esKeyword: true, esNested: true },
            'esData.person.dob': { label: "Birth Date", sortable: true, esSort: true, esKeyword: false, esNested: true },
            'esData.person.createdAt': { label: "Created", sortable: true, esSort: true, esKeyword: false, esNested: true, dateFilter: true },
            //company: { label: "Company", sortable: true, searchable: true, display: true, nested: "name"  }
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            keyword: false,
            perPage: 25,
          },
          currentSort: "createdAt",
          currentSortOrder: "desc",
          pagination: {
            perPage: 25,
            currentPage: 1,
            perPageOptions: [5, 10, 25, 50],
            total: 0
          },
          tableData: [],
          searchedData: [],

          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            if (data && data.searchPersonCompanys && data.searchPersonCompanys.items.length) {
              this.$c.log('formatResponse data', data.searchPersonCompanys.items);
              data.searchPersonCompanys.items.forEach((item) => {
                /** Store the PersonCompany.id in the person as relateRecordId */
                item.relateRecordId = item.id;                
                // replace id with person id
                item.id = item.person.id;
                if(item.esData){
                  let esData = JSON.parse(item.esData);

                  if(esData.person && esData.person.ssn){
                    esData.person.ssn = esData.person.ssn.replace(/.(?=.{4})/g, 'X');
                  }  
                  if(esData.person && esData.person.dob){
                    esData.person.dob = moment(esData.person.dob).format('MM/DD/YYYY')
                  }       
                  
                  item.esData = JSON.stringify(esData);

                }
            
                result.push(item);
              })
            }
            return result;
          },

        },

        // DO NOT MODIFY the list below to conform to conform with others.  the other list component is not ready.

        relatePersonsList: {
          hideListHeader: true,
          skipCardLayout: true,
          editPath: "people",
          pageTitle: "Search for Person",
          pageIcon: "people_alt",
          listQueryId: "searchPersons",
          createMutationId: "createPersonCompany",
          deleteQueryId: "deletePersonCompany",
          itemActions: [
            {
              class: "md-just-icon md-simple md-warning",
              classAdded: "item.added? 'check_circle' : 'md-warning'",
              icon: "post_add",
              iconAdded: "check_circle",
              click: "handleAdd"
            }
          ],
          columns: {
            given_name: { label: "First Name", sortable: true },
            family_name: { label: "Last Name", sortable: false },
            email: { label: "Email", sortable: false },
            createdAt: { label: "Created", sortable: true, dateFilter: true },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            this.$c.log(data);
            let result = [];
            let responseKey = 'searchPersons';
            if (data && data[responseKey] !== 'undefined') {
              let items = data[responseKey].items;
              items.forEach((item) => {
                /** Format the addresses for display */
                ['addressPhysical', 'addressMailing'].forEach(addressName => {
                  let itemAddress = item[addressName];
                  if (typeof itemAddress !== 'undefined' && itemAddress) {
                    item[addressName] = this.$format.JsonAddressToString(itemAddress);
                  }
                });
                result.push(item);
              })
            }
            return result;
          },
        },

        servicesList: {
          hideNewRecordButton: true,
          editPath: "services",
          pageTitle: "Services",
          pageIcon: "style",
          listQueryId: "searchServiceCustoms",
          responseFieldName: "searchServices",
          deleteQueryId: "deleteService",
          columns: {
            accountName: { label: "Account", sortable: false },
            name: { label: "DBA Name", sortable: true },
            nameLegal: { label: "Legal Name", sortable: true },
            merchantNumber: { label: "MID", sortable: true },
            status: { label: "Status", sortable: false },
            // salesRep: { label: "Sales Rep", sortable: false },
            portfolio: { label: "Portfolio", sortable: false },
            phoneBusiness: { label: "Primary Phone", sortable: false },
            physicalAddress: { label: "Physical Address", sortable: false },
            city: { label: "City", sortable: false },
            state: { label: "State", sortable: false },
            IPCorp: { label: "IP Corp", sortable: false },
            isRestructured: { label: "Restructured", sortable: false },
            dateSubmitted: { label: "Submitted", sortable: false  },
            approvalDate: { label: "Approved", sortable: false  },
            dateFirstProcessing: { label: "Processing Live", sortable: false  },
          },
          perPageOptions: [5, 10, 20, 25, 50],
          defaults: {
            sort: 'createdAt',
            sortDir: 'desc',
            perPage: 10,
          },
          fuseSearch: null,
          formatResponse: (data) => {
            let result = [];
            this.$c.log('inside services formatResponse: ', data);

            if (data && typeof data.searchServices !== 'undefined' && data.searchServices.items && data.searchServices.items.length) {
              let services = data.searchServices.items;
              services.forEach((item) => {
                item.accountName = (item.account && item.account.name)? item.account.name : '';
                item.phoneBusiness = item.phoneBusiness ? item.phoneBusiness : '';
                item.merchantNumber = item.merchantNumber ? item.merchantNumber : '';
                item.nameLegal = item.nameLegal ? item.nameLegal : '';
                item.IPCorp = item.IPCorp ? item.IPCorp : 'false';
                item.isRestructured = item.isRestructured ? item.isRestructured : 'false';
                item.dateSubmitted = item.dateSubmitted ? moment(item.dateSubmitted).format('MM/DD/YYYY') : "";
                item.approvalDate = item.approvalDate ? moment(item.approvalDate).format('MM/DD/YYYY')  : "";
                item.dateFirstProcessing = item.dateFirstProcessing ? moment(item.dateFirstProcessing).format('MM/DD/YYYY') : "";
                
                //get physicalAddress
                let itemAddress = item.addressPhysical;
                if (typeof itemAddress !== 'undefined' && itemAddress) {
                  try {
                    let parsedAddress = JSON.parse(itemAddress);
                    item.city = this.$reduce(parsedAddress, 'locality');
                    //let region = this.$reduce(parsedAddress, 'region') ? this.$reduce(parsedAddress, 'region').split('_') : ""; 
                    //item.state = region && region.length > 1 ? region[1] : this.$reduce(parsedAddress, 'region');
                    let region = parsedAddress.region.replace(/_/g, ' ').substring(2);
                    item.state = region;
                    item.physicalAddress = this.$reduce(parsedAddress, 'street_address');
                  } catch (error) {
                    console.log("Services => Json parse error", error)
                  }
                }

                if (typeof item.portfolios !== 'undefined' && item.portfolios && item.portfolios.items && item.portfolios.items.length) {
                  let firstPortfolio = item.portfolios.items[0].portfolio.name;
                  item.portfolio = firstPortfolio;                  
                }

                //get salesrep
                if (typeof item.cases !== 'undefined' && item.cases && item.cases.items && item.cases.items.length) {
                  let firstCase = item.cases.items[0].case;
                  if(firstCase && firstCase.salesreps && firstCase.salesreps && firstCase.salesreps.items && firstCase.salesreps.items.length) {
                    let salesrep = firstCase.salesreps.items[0].salesrep;
                    let givenName = salesrep.given_name ? salesrep.given_name : "";
                    let familyName = salesrep.family_name ? salesrep.family_name : "";
                    let salesrepName = `${givenName} ${familyName}`.trim();
                    item.salesRep = salesrepName;
                  }
                }

                //remove underscore from status
                if (typeof item.status !== 'undefined' && item.status) {
                  item.status = item.status.replace(/_/g, ' ');
                }
                result.push(item);
              })
            }

            return result;
          },
        },
        casesList: {
          listQueryId: "searchCaseCompanysCustom",
          listQueryTarget: "searchCaseCompanys",
          responseFieldName: "searchCaseCompanys",
          deleteQueryId: "deleteCaseCompany",
          filterListQueryId: "getListCaseStatusEnum",
          relateRecordInputField:"caseCompanyCaseId",
          createMutationId: "createCaseCompany",
          caseFromTab: 'Company',
          isSearchRecordsInput: true, //linker table search issue
        },
        tasksList: {
          listQueryId: "searchTaskCompanysCustoms",
          listQueryTarget: "searchTaskCompanys",
          responseFieldName: 'searchTaskCompanys',
          deleteQueryId: "deleteTaskCompany",
          filterListQueryId: "getListTaskStatusEnum",
          // caseMapIdFilter: {"taskCompanyCompanyId": {"eq": this.$route.params.id }}
        },
        form: {
          id: "",
          name: "",
          // phone: "",
          // phoneExt: "",
          // IPCorp: false,
          active: true,
        },
        formConfig: {
          hasUpdatedBy: true,
          updatedByFieldName: 'companyUpdatedById',
          responseFieldName: 'getCompany',
          actions: {
            save: 'createCompany',
            view: 'getCompany',
            edit: 'editCompany',
            new: 'getCompany',
            update: 'updateCompany',
            delete: 'deleteCompany',
          },
          listPath: "/companies",
          headerIcon: 'store',
          objectName: 'Company',
          objectNamePlural: 'Companies',
          editMode: false,
          pageMode: 'new', // can be one of ['new', 'view' 'edit']
          slots: {
            basic: {label: 'Basic Information', icon: 'work', layout: {"x":0,"y":0,"w":12,"h":18,"i":"0"}},
          },
          fields: {
            id: { label: "ID", type: "id", slot: 'basic', value: "" },
            name: { label: "Name", type: "text", slot: 'basic', value: "" },
            // IPCorp: { label: "IPCorp", type: "checkbox", slot: 'basic', value: false },
            active: { label: "Active", type: "switch", slot: 'basic', value: true },
          },
          editTitleField: 'name'
        },
        subscriptions: {
          'onCreatePersonCompany': {
            /** We will save the subscription to result so we can destroy it later */
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onCreatePersonCompany');
              let eventRecord = eventData.value.data.onCreatePersonCompany;
              /** Filter out records that do not apply to the Person we are looking at */
              if (this.recordData.id === eventRecord.company.id) {
                this.$c.log('SUBSCRIPTION MATCH: onCreatePersonCompany');
                window.setTimeout(() => {
                  this.$refs.personsListRef.refresh();
                  this.formConfig.refreshRecordData = true;
                }, 2000);  
              }
            }
          },
          'onDeletePersonCompany': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onDeletePersonCompany');
              let eventRecord = eventData.value.data.onDeletePersonCompany;
              if (this.recordData.id === eventRecord.company.id) {
                this.$c.log('SUBSCRIPTION MATCH: onDeletePersonCompany');
                window.setTimeout(() => {
                  this.$refs.companysListRef.refresh();
                  this.formConfig.refreshRecordData = true;
                }, 2000);     
              }
            }
          },
          'onUpdateCompany': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onUpdateCompany');
              let eventRecord = eventData.value.data.onUpdateCompany;
              if (this.recordData.id === eventRecord.id) {
                /** This Company was updated, we should refresh the data we have */
                /** Force a refresh on the ConfigForm component */
                this.formConfig.refreshRecordData = true;
              }
            }
          },
          'onDeleteCompany': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onDeleteCompany');
              let eventRecord = eventData.value.data.onDeleteCompany;
              if (this.recordData.id === eventRecord.id) {
                /** This Company was updated, we should refresh the data we have */
                /** Alert User and Redirect to list page */
                //TODO: Add notification for user
                this.$router.push("/companies");
              }
            }
          },
          'onUpdateAccount': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onUpdateAccount');
              let eventRecord = eventData.value.data.onUpdateAccount;
              if (eventRecord.accountCompanyId === this.recordData.id) {
                window.setTimeout(() => {
                  this.$refs.accountListRef.refresh();
                }, 500);
                /** Force a refresh on the ConfigForm component */
                this.formConfig.refreshRecordData = true;
              } else if(eventRecord.accountCompanyId === null) {
                //remove accountId from array on delete
                let skipAcc = this.accountsList.skipAccounts;
                var filteredArr = skipAcc.filter(e => e !== eventRecord.id);
                this.accountsList.skipAccounts = filteredArr;
              }
            },
          },
          'onCreateAccount': {
            result: null,
            load: true,
            function: (eventData) => {
              this.$c.log('SUBSCRIPTION Trigger: onCreateAccount');
              let eventRecord = eventData.value.data.onCreateAccount;
              if (eventRecord.accountCompanyId === this.recordData.id) {
                /** The event Record is associated with this Company */
                this.formConfig.refreshRecordData = true;
              }
            },
          },
        }
      }
    },
    validations() {
      return {
        form: {
          id: {},
          name: {required, minLength: minLength(3)},
          // phone: {},
          // phoneExt: {},
          // IPCorp: {},
          active: {},
        },
        // formConfig: {
        //   fields: {
        //     id: {value: {}},
        //     name: {value: {required, minLength: minLength(3)}},
        //     phone: {value: {required, minLength: minLength(3)}},
        //     phoneExt: {value: {required, numeric, minLength: minLength(3)}},
        //     status: {value: {}},
        //   }
        // }
      }
    }
  }
</script>

<style lang="scss">

  .md-tabs .md-tabs-navigation {
    padding-left: 15px;
    color: black;
    display: none;

    .md-tab-nav-button.md-button {
      color: black !important;

      &.active {
        color: black !important;
        border-bottom: 2px solid black;
      }
    }
  }

  .md-content .md-tabs-container .md-tab > .md-layout-item {
    padding-left: 0;
    padding-right: 0;
  }

  #tab-company .vue-grid-layout .vue-grid-item-content .field .form-field-view {
    margin-top: 6px;
  }
</style>